export default __webpack_public_path__ + "static/media/founder.b0486248.PNG";